export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_06.8963009b.jpg";